module.exports = __webpack_public_path__ + "img/verifyandpay-grey.dfd8b331.svg";